__turbopack_context__.v({
  "textSlider": "TextSlider-module-scss-module__RtyLBq__textSlider",
  "textSliderSection": "TextSlider-module-scss-module__RtyLBq__textSliderSection",
});
